import { ChargeUrl, DeleteCharge, AuthUrl } from '../components/Services/CommonServices';

/**
 * Utility functions for charge and authorization operations
 */

export const redirectToCharge = async (storeUrl, planTier = 'Pro', setChargeBtnLoad) => {
  try {
    setChargeBtnLoad(true);
    const res = await ChargeUrl(storeUrl, planTier);
    window.open(res, '_top');
  } catch (err) {
    console.error(`ChargeUrl error: ${JSON.stringify(err)}`);
    setChargeBtnLoad(false);
  }
};

export const deleteCharge = async (storeUrl, setBtnLoad, setToast, setPlanDowngrade) => {
  try {
    setBtnLoad(true);
    const res = await DeleteCharge(storeUrl);
    if (res) {
      setToast(true);
      setBtnLoad(false);
      setPlanDowngrade(false);
    } else {
      setBtnLoad(false);
    }
  } catch (err) {
    console.error(`DeleteCharge error: ${JSON.stringify(err)}`);
    setBtnLoad(false);
  }
};

export const redirectToAppUpdate = async (pathname, storeUrl) => {
  const routeTypeMap = {
    '/customers': 'customer',
    '/metaobjects': 'metaobject',
    '/definitions': 'metaobject',
    // '/orders': 'order',
    '/translations': 'translation',
    '/menu': 'menu',
    'default': 'page'
  };

  const type = routeTypeMap[pathname] || routeTypeMap['default'];

  try {
    const res = await AuthUrl(storeUrl, type);
    window.open(res, '_top');
  } catch (err) {
    console.error(`AuthUrl error: ${JSON.stringify(err)}`);
  }
};
